__webpack_require__.p = "/Vue2_RWM_Demo/";